/**
 * Shapes the ngx-charts widgets on the warehousing dashboard bind to.
 *
 * `WarehousingChart` carries the decision about *whether* to draw as well as the data,
 * because several of these forms stop being honest below a data floor — a two-slice pie or
 * a one-bar trend line. The template asks `renderable` rather than guessing from length.
 */

export class ChartSeries {
  name: string = '';
  value: number = 0;
}

export class ChartGroup {
  name: string = '';
  series: ChartSeries[] = [];
}

export class WarehousingChart {
  /** False when the data cannot support this form — the template shows a fallback. */
  renderable: boolean = false;

  /**
   * Why it is not renderable, or a caveat about what had to be left out. Shown to the
   * reader rather than leaving a blank card, which would read as a broken screen.
   */
  suppressedBecause: string = '';

  data: any[] = [];

  /**
   * Explicit name -> colour pairs. ngx-charts otherwise assigns `scheme.domain` by series
   * *position*, so filtering one warehouse out silently repaints the survivors and a reader
   * who learned "Main Depot is blue" is misled. Binding customColors keyed on the entity
   * name pins the hue to the entity instead.
   */
  customColors: any[] = [];

  /**
   * Charted label -> full entity name.
   *
   * ngx-charts truncates every legend label to 10 characters internally, with no input to
   * change it. Real warehouse names share a prefix — "Blacks Main Depot" and "Blacks
   * Secondary Depot" both truncate to "Blacks ...", so the legend showed two identical
   * entries and could not distinguish the sites at all. Charts therefore plot a
   * prefix-stripped label, and this maps back so the table twin can still show the real name.
   */
  labelMap: any = {};
}
